// 引入数据配置文件
import FormConfig from "./formConfig.js";
import { fun_PostAction, fun_GetAction } from "@/api/index";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 操作类型
      controllerFlg: null, // 操作标志
      // 主键
      id: null, // 主键
      // 勾选的数据
      multipleSelection: [],
      // 表格基础数据
      tableColumns: [
        {
          label: "资质类型",
          prop: "certTypeNum",
          width: "250",
          fixed: true,
        },
        {
          label: "资质分类",
          prop: "tradeLargeClass",
          width: "250",
          fixed: true,
        },
        {
          label: "资质专业",
          prop: "tradeCategoryCode",
          width: "350",
        },
        {
          label: "资质等级（含及以上）",
          prop: "certTypeLevel",
          width: "150",
        },
        {
          label: "备注",
          prop: "description",
          width: "200",
        },
      ],
      // 表单绑定数据
      formObj: {
        // 表格数据
        tableData: [],
      },
      // 列表绑定验证规则
      rules: {
        certTypeNum: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
        tradeLargeClass: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
        tradeCategoryCode: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
        certTypeLevel: [
          {
            required: true,
            message: "该输入项为必输项",
            trigger: "blur"
          },
        ],
      },
      // 表头按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 表单对象
      form: {
        abilityReputation: null, // 对投标人要求
      },
      // 表单错误
      errRules: {

      },
      // 资质分类下拉框数据
      tradeLargeClassOptions: [],
      // 专业小类下拉框数据
      tradeCategoryCodeOptions: [],
      // 资质等级下拉框数据
      certTypeLevelOptions: [],
      // 表单配置
      formConfigList: FormConfig.configList(),
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open() {
      // 如果是详情
      if (this.controllerFlg === 'detail') {
        // 清空表头
        this.btnList = [];
        // 遍历
        this.formConfigList.map(item => {
          // 遍历
          item.formConfigList.map(e => {
            // 禁止输入
            e.disabled = true;
          })
        })
      }
      // 获取一览表单
      this.fun_GetList();
    },
    /**
    * 获取一览表格数据
    * @author 付翔
    */
    fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        fun_PostAction("/tenderRegistration/tendererRequirementList", {
          registrationId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 判断请求是否成功
          if (result) {
            // 关闭loading
            this.loading = false;
            // 回显table
            this.formObj.tableData = data;
            // 遍历
            this.formObj.tableData.map((value, index) => {
              // 资质类型下拉框赋值
              this.fun_SetCertTypeNum(value, index);
            })
          } else {
            // 关闭loading
            this.loading = false;
            // 提示请求失败消息
            this.$message.error(msg);
          }
        });
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            certTypeNum: null,
            tradeLargeClass: null,
            tradeCategoryCode: null,
            certTypeLevel: null,
          };
          //添加新的行数
          this.formObj.tableData.push(newValue);
          break;
        default:
          // 判断是否勾选
          if(this.multipleSelection.length <= 0){
            // 提示信息
            this.$alert("最少选择一条数据！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 遍历
            this.multipleSelection.map((value, index) => {
              // 遍历
              this.formObj.tableData.map((v, i) => {
                // 匹配已选中的
                if (value.index === v.index) {
                  // 删除勾选的数据
                  this.formObj.tableData.splice(i, 1);
                }
              });
            });
            // 清除选中数据
            this.$refs.multipleTable.clearSelection();
          });
      }
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index"
      }
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 列表勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值勾选数组
      this.multipleSelection = e;
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },
    /**
     * 设置资质类型
     */
    fun_SetCertTypeNum(e, i) {
      // 获取资质分类下拉框
      this.fun_GetTradeLargeClass(e.certTypeNum, i);
      // 获取资质分类下拉框
      this.fun_GetTradeCategoryCode(e.tradeLargeClass, i);
      // 获取资质等级下拉框
      this.fun_GetCertTypeLevel(e.certTypeNum, i);
    },
    /**
     * 资质类型下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeCertTypeNum(e, i) {
      // 赋值
      this.formObj.tableData[i].certTypeNum = e;
      // 清空资质分类，资质专业，资质等级
      this.formObj.tableData[i].tradeLargeClass = '';
      this.formObj.tableData[i].tradeCategoryCode = '';
      this.formObj.tableData[i].certTypeLevel = '';
      // 获取资质分类下拉框
      this.fun_GetTradeLargeClass(e,i);
      // 获取资质等级下拉框
      this.fun_GetCertTypeLevel(e,i);
    },

    /**
     * 资质分类下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeTradeLargeClass(e, i) {
      // 赋值
      this.formObj.tableData[i].tradeLargeClass = e;
      // 清空资质专业，资质等级
      this.formObj.tableData[i].tradeCategoryCode = '';
      this.formObj.tableData[i].certTypeLevel = '';
      // 获取资质专业下拉框
      this.fun_GetTradeCategoryCode(e,i);
    },
    /**
     * 获取资质分类下拉框
     * @author shuhua
     */
    fun_GetTradeLargeClass(e,i) {
      // 获取value值
      e = e.substring(e.indexOf('|')+1,e.length);
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/CertQualificationListComboBox", {
        typNum: e,
        rowNum:i
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 专业类别下拉框数据
          this.tradeLargeClassOptions.splice(i,1,data);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取资质分类下拉框
     * @author shuhua
     */
    fun_GetCertTypeLevel(e,i) {

      // 获取value值
      e = e.substring(e.indexOf('|')+1,e.length);
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/CertTitleTypeNumComboBox", {
        typNum: e,
        rowNum:i
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 专业类别下拉框数据
          this.certTypeLevelOptions.splice(i,1,data);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取资质专业下拉框
     * @author shuhua
     */
    fun_GetTradeCategoryCode(e,i) {
      // 获取value值
      e = e.substring(e.indexOf('|')+1,e.length);
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/TradeCategoryComboBox", {
        typNum: e,
        rowNum:i
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 专业类别下拉框数据
          this.tradeCategoryCodeOptions.splice(i,1,data);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
  }
};
